// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/AdminPortal/Business/Business.css */

.business-container {
    max-width: 1280px;
    min-height: calc(100vh - 12vh);
    margin: 0 auto;
    padding: 24px;
    background: linear-gradient(180deg, #f4f7fb 0%, #eef4f8 100%);
    color: #243447;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.business-container::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        linear-gradient(135deg, rgba(239, 111, 83, 0.12), transparent 28%),
        linear-gradient(315deg, rgba(25, 118, 210, 0.1), transparent 34%);
    pointer-events: none;
}

.business-container > * {
    position: relative;
    z-index: 1;
}

.business-container *,
.business-container *::before,
.business-container *::after {
    box-sizing: border-box;
}

.business-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 22px 24px;
    margin-bottom: 20px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 8px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)),
        linear-gradient(90deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.12);
    position: relative;
    overflow: hidden;
}

.business-page-header::before {
    content: '';
    position: absolute;
    inset: 0 0 auto 0;
    height: 4px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
}

.business-page-header > div {
    flex: 1 1;
    text-align: center;
}

.business-eyebrow {
    display: inline-flex;
    color: #EF6F53;
    font-size: 0.76rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0;
    margin-bottom: 4px;
}

.business-container h2 {
    color: #243447;
    font-size: 1.85rem;
    line-height: 1.15;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
    overflow-wrap: anywhere;
}

.business-page-header p {
    margin: 5px 0 0;
    color: #66788f;
    font-size: 0.92rem;
    font-weight: 700;
}

.add-business-btn {
    background: linear-gradient(135deg, #EF6F53, #d85a41);
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 0.92rem;
    font-weight: 800;
    white-space: nowrap;
    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
    position: absolute;
    right: 20px;
}

.add-business-btn:hover {
    filter: brightness(1.03);
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);
}

.business-form {
    padding: 18px;
    border-radius: 8px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);
    margin-bottom: 20px;
}

.business-form h3 {
    color: #364C63;
    margin-bottom: 5px;
    font-size: 18px;
}

.formm-section {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.form-rowww {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
}

.form-groupppp {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.form-groupppp label {
    font-size: 14px;
    font-weight: 800;
    color: #364C63;
    min-width: 120px;
    text-align: right;
}

.form-groupppp .input-container {
    flex: 1 1;
    display: flex;
    position: relative;
}

.form-groupppp input,
.form-groupppp textarea {
    border: 1px solid rgba(54, 76, 99, 0.18);
    border-radius: 7px;
    font-size: 12px;
    width: 100%;
    padding: 7px 9px;
    background: #ffffff;
    transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-groupppp textarea {
    resize: vertical;
}

.form-groupppp input:focus,
.form-groupppp textarea:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);
}

.password-group {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.password-group label {
    min-width: 120px;
    text-align: right;
}

.password-input-container {
    flex: 1 1;
    position: relative;
}

.password-input-container input {
    width: 100%;
    padding-right: 40px;
}

.password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    color: #666;
}

.password-toggle:hover {
    color: #2c3e50;
}

.password-toggle i {
    font-size: 16px;
}

.businesses-list {
    width: 100%;
    margin-top: 1rem;
    overflow: hidden;
    padding: 18px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 8px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96));
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);
}

.agent-stats-config-form {
    padding: 14px;
    margin-bottom: 18px;
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);
}

.agent-stats-config-form h3 {
    margin: 0;
    color: #243447;
    font-size: 1rem;
    font-weight: 900;
    text-align: center;
}

.agent-stats-config-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.agent-stats-config-heading button {
    flex: 0 0 auto;
    border: 1px solid rgba(220, 53, 69, 0.22);
    border-radius: 7px;
    background: #fff1f2;
    color: #b42335;
    cursor: pointer;
    font-size: 0.76rem;
    font-weight: 900;
    padding: 7px 10px;
    transition: transform 160ms ease, filter 160ms ease;
}

.agent-stats-config-heading button:hover {
    filter: brightness(0.98);
    transform: translateY(-1px);
}

.agent-stats-config-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.agent-stats-config-grid label {
    display: grid;
    gap: 4px;
    color: #364C63;
    font-size: 0.78rem;
    font-weight: 800;
}

.agent-stats-timing-section {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 4px;
    padding-top: 12px;
    border-top: 1px solid rgba(54, 76, 99, 0.2);
}

.agent-stats-timing-section label {
    padding: 10px;
    border: 1px solid rgba(25, 118, 210, 0.14);
    border-radius: 8px;
    background: linear-gradient(180deg, rgba(25, 118, 210, 0.06), rgba(255, 255, 255, 0.92));
}

.agent-stats-field-note {
    color: #5d7281;
    font-size: 0.68rem;
    font-weight: 600;
    line-height: 1.3;
}

.agent-stats-config-grid input,
.agent-stats-config-grid select {
    width: 100%;
    padding: 7px 9px;
    border: 1px solid rgba(54, 76, 99, 0.18);
    border-radius: 7px;
    font-size: 0.84rem;
    background-color: white;
}

.agent-stats-config-toggle {
    display: flex !important;
    align-items: center;
    gap: 7px;
    grid-template-columns: none !important;
}

.agent-stats-config-toggle input {
    width: auto;
}

.agent-stats-help {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    background: #24516f;
    color: white;
    cursor: help;
    font-size: 0.68rem;
    font-weight: 900;
    line-height: 1;
}

.agent-stats-config-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
}

.agent-stats-config-actions button,
.agent-config-button {
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.agent-stats-config-actions button {
    padding: 7px 14px;
}

.agent-stats-config-actions button:first-child,
.agent-config-button {
    background: #24516f;
    color: #ffffff;
}

.agent-stats-config-actions button:last-child {
    background: #eef2f6;
    color: #364C63;
    border: 1px solid rgba(54, 76, 99, 0.16);
}

.agent-stats-config-actions button:hover,
.agent-config-button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
}

.business-list-title {
    text-align: center;
    margin: 0 0 1rem;
    color: #243447;
    font-size: 1.25rem;
    font-weight: 900;
    text-transform: uppercase;
    position: relative;
    padding-bottom: 9px;
}

.business-list-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 72px;
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
    transform: translateX(-50%);
}

.business-cards-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    padding: 8px 4px 14px;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #EF6F53 #CFD8DC;
    -webkit-overflow-scrolling: touch;
}

.business-cards-container::-webkit-scrollbar {
    height: 8px;
}

.business-cards-container::-webkit-scrollbar-track {
    background: #CFD8DC;
    border-radius: 4px;
}

.business-cards-container::-webkit-scrollbar-thumb {
    background-color: #EF6F53;
    border-radius: 4px;
}

.business-cards-container::-webkit-scrollbar-thumb:hover {
    background-color: #EF6F53;
}

.business-card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-left: 4px solid #EF6F53;
    box-shadow: 0 12px 28px rgba(54, 76, 99, 0.12);
    padding: 0;
    cursor: pointer;
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
    flex: 0 0 auto;
    width: 340px;
    position: relative;
    overflow: hidden;
}

.business-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
}

.business-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);
    border-color: rgba(239, 111, 83, 0.28);
}

.business-info {
    padding: 12px 12px 8px;
}

.business-info h3 {
    color: #243447;
    border-bottom: 0;
    margin: 4px 0 8px;
    padding-bottom: 0;
    font-size: 1.16rem;
    line-height: 1.25;
    font-weight: 900;
    overflow-wrap: anywhere;
}

.business-info p {
    display: grid;
    grid-template-columns: 108px minmax(0, 1fr);
    gap: 5px;
    align-items: start;
    margin: 0 0 5px;
    padding: 5px 7px;
    border-radius: 7px;
    background: #f8fafc;
    border: 1px solid rgba(54, 76, 99, 0.07);
    color: #364C63;
    font-size: 0.9rem;
    text-align: left;
    overflow-wrap: anywhere;
}

.business-info strong {
    color: #24516f;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0;
}

.business-receptionists-summary {
    margin-top: 6px;
    padding: 7px;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));
    border: 1px solid rgba(25, 118, 210, 0.12);
}

.business-receptionists-summary > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    margin-bottom: 4px;
}

.business-receptionists-summary strong {
    color: #24516f;
    font-size: 0.78rem;
    font-weight: 900;
    text-transform: uppercase;
}

.business-receptionists-summary span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 24px;
    padding: 0 8px;
    border-radius: 999px;
    background: #EF6F53;
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 900;
}

.business-receptionists-summary p {
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #364C63;
    font-size: 0.9rem;
    font-weight: 700;
}

.business-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0;
    border-top: 1px solid rgba(54, 76, 99, 0.1);
    padding: 8px 12px 10px;
    background: linear-gradient(180deg, #ffffff, #f8fafc);
}

.business-actions button {
    flex: 1 1 auto;
    min-width: 82px;
    padding: 6px 8px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 12px;
    transition: transform 160ms ease, filter 160ms ease;
}

.business-actions button:first-child {
    background-color: #24516f;
    color: white;
}

.business-actions button:nth-child(2) {
    background-color: #dc3545;
    color: white;
}

.business-actions button:nth-child(3) {
    background-color: #1976d2;
    color: white;
}

.business-actions .receptionist-button {
    background: linear-gradient(135deg, #1976d2, #24516f);
    color: white;
    flex-basis: 100%;
}

.business-actions .agent-config-button {
    background: linear-gradient(135deg, #7c3aed, #db2777);
    color: white;
    border: 1px solid rgba(124, 58, 237, 0.35);
    box-shadow: 0 6px 14px rgba(124, 58, 237, 0.2);
    flex-basis: 100%;
    padding: 6px 8px;
    font-size: 12px;
}

.business-actions button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
}

.business-actions button:active {
    transform: translateY(0);
}

.brand-name-heading {
    display: inline-flex;
    max-width: 100%;
    color: #EF6F53;
    background: rgba(239, 111, 83, 0.1);
    border: 1px solid rgba(239, 111, 83, 0.18);
    border-radius: 999px;
    padding: 4px 9px;
    font-size: 0.78rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0;
    overflow-wrap: anywhere;
}

.error-message {
    background-color: #fce4e4;
    border: 1px solid #fcc2c3;
    color: #cc0033;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.success-message {
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.loading {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 16px;
}

.info-icon-container {
    position: relative;
    display: inline-flex;   
    align-items: center;
    margin-right: 8px;
    margin-left: 2px;
    text-align: left;

}

.info-icon {
    color: #3498db;
    cursor: help;
    font-size: 12px;
}

.info-tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: -10px;
    top: 25px;
    background-color: #2c3e50;
    color: #ecf0f1;
    padding: 8px;
    border-radius: 4px;
    width: 450px;
    font-size: 12px;
    line-height: 1.3;
    z-index: 1000;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}

.info-tooltip p {
    margin: 0;
    align-items: left;
}

.info-tooltip br {
    display: block;
    content: "";
    margin-top: 4px;
}

.info-tooltip p:first-child {
    font-weight: 500;
    color: #2ecc71;
    margin-bottom: 4px;
}

.info-tooltip a {
    color: #3498db;
    text-decoration: none;
}

.info-tooltip a:hover {
    text-decoration: underline;
}

.info-tooltip p:last-child {
    margin-bottom: 0;
}

.info-tooltip::before {
    content: "";
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 6px 6px 6px 0;
    border-style: solid;
    border-color: transparent #2c3e50 transparent transparent;
}

.info-icon-container:hover .info-tooltip {
    visibility: visible;
    opacity: 1;
}

.password-label-group {
    display: flex;
    align-items: center;
    min-width: 140px;
    justify-content: flex-end;
    gap: 4px;
}

.forrm-actions {
    display: flex;
    gap: 5px;
    justify-content: center;
}

.forrm-actions button {
    padding: 7px 14px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.forrm-actions button[type="submit"] {
    background-color: #24516f;
    color: white;
}

.forrm-actions button[type="submit"]:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.forrm-actions button[type="button"] {
    background-color: #eef2f6;
    color: #364C63;
    border: 1px solid rgba(54, 76, 99, 0.16);
}

.forrm-actions button[type="button"]:hover {
    filter: brightness(0.98);
    transform: translateY(-1px);
}

.forrm-actions button:active {
    transform: scale(0.98);
}

@media (max-width: 900px) {
    .business-container {
        padding: 14px;
    }

    .business-page-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .business-page-header > div {
        width: 100%;
    }

    .add-business-btn {
        position: static;
        align-self: center;
    }

    .form-rowww {
        flex-direction: column;
    }

    .agent-stats-config-grid {
        grid-template-columns: 1fr;
    }

    .agent-stats-config-heading {
        align-items: stretch;
        flex-direction: column;
    }

    .agent-stats-timing-section {
        grid-template-columns: 1fr;
    }

    .form-groupppp {
        align-items: stretch;
        flex-direction: column;
    }

    .form-groupppp label,
    .password-group label,
    .password-label-group {
        justify-content: flex-start;
        min-width: 0;
        text-align: left;
    }
}

@media (max-width: 560px) {
    .business-container h2 {
        font-size: 1.45rem;
    }

    .add-business-btn {
        width: 100%;
    }

    .business-card {
        width: 290px;
    }

    .business-info p {
        grid-template-columns: 1fr;
        gap: 3px;
    }

    .business-actions {
        justify-content: flex-start;
    }

    .info-tooltip {
        width: min(82vw, 360px);
        left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/AdminPortal/Business/Business.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,aAAa;IACb,6DAA6D;IAC7D,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;yEAEqE;IACrE,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB;;iFAE6E;IAC7E,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gDAAgD;IAChD,0EAA0E;IAC1E,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,qCAAqC;IACrC,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB;qFACiF;IACjF,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,wFAAwF;AAC5F;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,QAAQ;IACR,sCAAsC;AAC1C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;;IAEI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,8BAA8B;IAC9B,8CAA8C;IAC9C,UAAU;IACV,eAAe;IACf,gFAAgF;IAChF,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sFAAsF;IACtF,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,2CAA2C;IAC3C,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,mCAAmC;IACnC,0CAA0C;IAC1C,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;;;QAGI,2BAA2B;QAC3B,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;QACvB,OAAO;IACX;AACJ","sourcesContent":["/* src/components/routes/Forms/AdminPortal/Business/Business.css */\n\n.business-container {\n    max-width: 1280px;\n    min-height: calc(100vh - 12vh);\n    margin: 0 auto;\n    padding: 24px;\n    background: linear-gradient(180deg, #f4f7fb 0%, #eef4f8 100%);\n    color: #243447;\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n}\n\n.business-container::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background:\n        linear-gradient(135deg, rgba(239, 111, 83, 0.12), transparent 28%),\n        linear-gradient(315deg, rgba(25, 118, 210, 0.1), transparent 34%);\n    pointer-events: none;\n}\n\n.business-container > * {\n    position: relative;\n    z-index: 1;\n}\n\n.business-container *,\n.business-container *::before,\n.business-container *::after {\n    box-sizing: border-box;\n}\n\n.business-page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 22px 24px;\n    margin-bottom: 20px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 8px;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)),\n        linear-gradient(90deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.12);\n    position: relative;\n    overflow: hidden;\n}\n\n.business-page-header::before {\n    content: '';\n    position: absolute;\n    inset: 0 0 auto 0;\n    height: 4px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n}\n\n.business-page-header > div {\n    flex: 1;\n    text-align: center;\n}\n\n.business-eyebrow {\n    display: inline-flex;\n    color: #EF6F53;\n    font-size: 0.76rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    margin-bottom: 4px;\n}\n\n.business-container h2 {\n    color: #243447;\n    font-size: 1.85rem;\n    line-height: 1.15;\n    font-weight: 900;\n    text-transform: uppercase;\n    margin: 0;\n    overflow-wrap: anywhere;\n}\n\n.business-page-header p {\n    margin: 5px 0 0;\n    color: #66788f;\n    font-size: 0.92rem;\n    font-weight: 700;\n}\n\n.add-business-btn {\n    background: linear-gradient(135deg, #EF6F53, #d85a41);\n    color: white;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 0.92rem;\n    font-weight: 800;\n    white-space: nowrap;\n    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);\n    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;\n    position: absolute;\n    right: 20px;\n}\n\n.add-business-btn:hover {\n    filter: brightness(1.03);\n    transform: translateY(-2px);\n    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);\n}\n\n.business-form {\n    padding: 18px;\n    border-radius: 8px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    background: rgba(255, 255, 255, 0.97);\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);\n    margin-bottom: 20px;\n}\n\n.business-form h3 {\n    color: #364C63;\n    margin-bottom: 5px;\n    font-size: 18px;\n}\n\n.formm-section {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.form-rowww {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.form-groupppp {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.form-groupppp label {\n    font-size: 14px;\n    font-weight: 800;\n    color: #364C63;\n    min-width: 120px;\n    text-align: right;\n}\n\n.form-groupppp .input-container {\n    flex: 1;\n    display: flex;\n    position: relative;\n}\n\n.form-groupppp input,\n.form-groupppp textarea {\n    border: 1px solid rgba(54, 76, 99, 0.18);\n    border-radius: 7px;\n    font-size: 12px;\n    width: 100%;\n    padding: 7px 9px;\n    background: #ffffff;\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.form-groupppp textarea {\n    resize: vertical;\n}\n\n.form-groupppp input:focus,\n.form-groupppp textarea:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);\n}\n\n.password-group {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.password-group label {\n    min-width: 120px;\n    text-align: right;\n}\n\n.password-input-container {\n    flex: 1;\n    position: relative;\n}\n\n.password-input-container input {\n    width: 100%;\n    padding-right: 40px;\n}\n\n.password-toggle {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 5px;\n    color: #666;\n}\n\n.password-toggle:hover {\n    color: #2c3e50;\n}\n\n.password-toggle i {\n    font-size: 16px;\n}\n\n.businesses-list {\n    width: 100%;\n    margin-top: 1rem;\n    overflow: hidden;\n    padding: 18px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 8px;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96));\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);\n}\n\n.agent-stats-config-form {\n    padding: 14px;\n    margin-bottom: 18px;\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);\n}\n\n.agent-stats-config-form h3 {\n    margin: 0;\n    color: #243447;\n    font-size: 1rem;\n    font-weight: 900;\n    text-align: center;\n}\n\n.agent-stats-config-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.agent-stats-config-heading button {\n    flex: 0 0 auto;\n    border: 1px solid rgba(220, 53, 69, 0.22);\n    border-radius: 7px;\n    background: #fff1f2;\n    color: #b42335;\n    cursor: pointer;\n    font-size: 0.76rem;\n    font-weight: 900;\n    padding: 7px 10px;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.agent-stats-config-heading button:hover {\n    filter: brightness(0.98);\n    transform: translateY(-1px);\n}\n\n.agent-stats-config-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.agent-stats-config-grid label {\n    display: grid;\n    gap: 4px;\n    color: #364C63;\n    font-size: 0.78rem;\n    font-weight: 800;\n}\n\n.agent-stats-timing-section {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    margin-top: 4px;\n    padding-top: 12px;\n    border-top: 1px solid rgba(54, 76, 99, 0.2);\n}\n\n.agent-stats-timing-section label {\n    padding: 10px;\n    border: 1px solid rgba(25, 118, 210, 0.14);\n    border-radius: 8px;\n    background: linear-gradient(180deg, rgba(25, 118, 210, 0.06), rgba(255, 255, 255, 0.92));\n}\n\n.agent-stats-field-note {\n    color: #5d7281;\n    font-size: 0.68rem;\n    font-weight: 600;\n    line-height: 1.3;\n}\n\n.agent-stats-config-grid input,\n.agent-stats-config-grid select {\n    width: 100%;\n    padding: 7px 9px;\n    border: 1px solid rgba(54, 76, 99, 0.18);\n    border-radius: 7px;\n    font-size: 0.84rem;\n    background-color: white;\n}\n\n.agent-stats-config-toggle {\n    display: flex !important;\n    align-items: center;\n    gap: 7px;\n    grid-template-columns: none !important;\n}\n\n.agent-stats-config-toggle input {\n    width: auto;\n}\n\n.agent-stats-help {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 17px;\n    height: 17px;\n    border-radius: 50%;\n    background: #24516f;\n    color: white;\n    cursor: help;\n    font-size: 0.68rem;\n    font-weight: 900;\n    line-height: 1;\n}\n\n.agent-stats-config-actions {\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 12px;\n}\n\n.agent-stats-config-actions button,\n.agent-config-button {\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.agent-stats-config-actions button {\n    padding: 7px 14px;\n}\n\n.agent-stats-config-actions button:first-child,\n.agent-config-button {\n    background: #24516f;\n    color: #ffffff;\n}\n\n.agent-stats-config-actions button:last-child {\n    background: #eef2f6;\n    color: #364C63;\n    border: 1px solid rgba(54, 76, 99, 0.16);\n}\n\n.agent-stats-config-actions button:hover,\n.agent-config-button:hover {\n    filter: brightness(1.05);\n    transform: translateY(-1px);\n}\n\n.business-list-title {\n    text-align: center;\n    margin: 0 0 1rem;\n    color: #243447;\n    font-size: 1.25rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    position: relative;\n    padding-bottom: 9px;\n}\n\n.business-list-title::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    width: 72px;\n    height: 3px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n    transform: translateX(-50%);\n}\n\n.business-cards-container {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    padding: 8px 4px 14px;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #EF6F53 #CFD8DC;\n    -webkit-overflow-scrolling: touch;\n}\n\n.business-cards-container::-webkit-scrollbar {\n    height: 8px;\n}\n\n.business-cards-container::-webkit-scrollbar-track {\n    background: #CFD8DC;\n    border-radius: 4px;\n}\n\n.business-cards-container::-webkit-scrollbar-thumb {\n    background-color: #EF6F53;\n    border-radius: 4px;\n}\n\n.business-cards-container::-webkit-scrollbar-thumb:hover {\n    background-color: #EF6F53;\n}\n\n.business-card {\n    background: #ffffff;\n    border-radius: 8px;\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-left: 4px solid #EF6F53;\n    box-shadow: 0 12px 28px rgba(54, 76, 99, 0.12);\n    padding: 0;\n    cursor: pointer;\n    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n    flex: 0 0 auto;\n    width: 340px;\n    position: relative;\n    overflow: hidden;\n}\n\n.business-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n}\n\n.business-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);\n    border-color: rgba(239, 111, 83, 0.28);\n}\n\n.business-info {\n    padding: 12px 12px 8px;\n}\n\n.business-info h3 {\n    color: #243447;\n    border-bottom: 0;\n    margin: 4px 0 8px;\n    padding-bottom: 0;\n    font-size: 1.16rem;\n    line-height: 1.25;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n}\n\n.business-info p {\n    display: grid;\n    grid-template-columns: 108px minmax(0, 1fr);\n    gap: 5px;\n    align-items: start;\n    margin: 0 0 5px;\n    padding: 5px 7px;\n    border-radius: 7px;\n    background: #f8fafc;\n    border: 1px solid rgba(54, 76, 99, 0.07);\n    color: #364C63;\n    font-size: 0.9rem;\n    text-align: left;\n    overflow-wrap: anywhere;\n}\n\n.business-info strong {\n    color: #24516f;\n    font-size: 0.78rem;\n    text-transform: uppercase;\n    letter-spacing: 0;\n}\n\n.business-receptionists-summary {\n    margin-top: 6px;\n    padding: 7px;\n    border-radius: 8px;\n    background: linear-gradient(135deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));\n    border: 1px solid rgba(25, 118, 210, 0.12);\n}\n\n.business-receptionists-summary > div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: 4px;\n}\n\n.business-receptionists-summary strong {\n    color: #24516f;\n    font-size: 0.78rem;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.business-receptionists-summary span {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 26px;\n    height: 24px;\n    padding: 0 8px;\n    border-radius: 999px;\n    background: #EF6F53;\n    color: #ffffff;\n    font-size: 0.8rem;\n    font-weight: 900;\n}\n\n.business-receptionists-summary p {\n    display: block;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #364C63;\n    font-size: 0.9rem;\n    font-weight: 700;\n}\n\n.business-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 0;\n    border-top: 1px solid rgba(54, 76, 99, 0.1);\n    padding: 8px 12px 10px;\n    background: linear-gradient(180deg, #ffffff, #f8fafc);\n}\n\n.business-actions button {\n    flex: 1 1 auto;\n    min-width: 82px;\n    padding: 6px 8px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-weight: 800;\n    text-transform: uppercase;\n    font-size: 12px;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.business-actions button:first-child {\n    background-color: #24516f;\n    color: white;\n}\n\n.business-actions button:nth-child(2) {\n    background-color: #dc3545;\n    color: white;\n}\n\n.business-actions button:nth-child(3) {\n    background-color: #1976d2;\n    color: white;\n}\n\n.business-actions .receptionist-button {\n    background: linear-gradient(135deg, #1976d2, #24516f);\n    color: white;\n    flex-basis: 100%;\n}\n\n.business-actions .agent-config-button {\n    background: linear-gradient(135deg, #7c3aed, #db2777);\n    color: white;\n    border: 1px solid rgba(124, 58, 237, 0.35);\n    box-shadow: 0 6px 14px rgba(124, 58, 237, 0.2);\n    flex-basis: 100%;\n    padding: 6px 8px;\n    font-size: 12px;\n}\n\n.business-actions button:hover {\n    filter: brightness(1.05);\n    transform: translateY(-1px);\n}\n\n.business-actions button:active {\n    transform: translateY(0);\n}\n\n.brand-name-heading {\n    display: inline-flex;\n    max-width: 100%;\n    color: #EF6F53;\n    background: rgba(239, 111, 83, 0.1);\n    border: 1px solid rgba(239, 111, 83, 0.18);\n    border-radius: 999px;\n    padding: 4px 9px;\n    font-size: 0.78rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    overflow-wrap: anywhere;\n}\n\n.error-message {\n    background-color: #fce4e4;\n    border: 1px solid #fcc2c3;\n    color: #cc0033;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.success-message {\n    background-color: #d4edda;\n    border: 1px solid #c3e6cb;\n    color: #155724;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.info-icon-container {\n    position: relative;\n    display: inline-flex;   \n    align-items: center;\n    margin-right: 8px;\n    margin-left: 2px;\n    text-align: left;\n\n}\n\n.info-icon {\n    color: #3498db;\n    cursor: help;\n    font-size: 12px;\n}\n\n.info-tooltip {\n    visibility: hidden;\n    opacity: 0;\n    position: absolute;\n    left: -10px;\n    top: 25px;\n    background-color: #2c3e50;\n    color: #ecf0f1;\n    padding: 8px;\n    border-radius: 4px;\n    width: 450px;\n    font-size: 12px;\n    line-height: 1.3;\n    z-index: 1000;\n    transform: translateY(-10px);\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.15);\n}\n\n.info-tooltip p {\n    margin: 0;\n    align-items: left;\n}\n\n.info-tooltip br {\n    display: block;\n    content: \"\";\n    margin-top: 4px;\n}\n\n.info-tooltip p:first-child {\n    font-weight: 500;\n    color: #2ecc71;\n    margin-bottom: 4px;\n}\n\n.info-tooltip a {\n    color: #3498db;\n    text-decoration: none;\n}\n\n.info-tooltip a:hover {\n    text-decoration: underline;\n}\n\n.info-tooltip p:last-child {\n    margin-bottom: 0;\n}\n\n.info-tooltip::before {\n    content: \"\";\n    position: absolute;\n    left: -6px;\n    top: 50%;\n    transform: translateY(-50%);\n    border-width: 6px 6px 6px 0;\n    border-style: solid;\n    border-color: transparent #2c3e50 transparent transparent;\n}\n\n.info-icon-container:hover .info-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n.password-label-group {\n    display: flex;\n    align-items: center;\n    min-width: 140px;\n    justify-content: flex-end;\n    gap: 4px;\n}\n\n.forrm-actions {\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n}\n\n.forrm-actions button {\n    padding: 7px 14px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.forrm-actions button[type=\"submit\"] {\n    background-color: #24516f;\n    color: white;\n}\n\n.forrm-actions button[type=\"submit\"]:hover {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.forrm-actions button[type=\"button\"] {\n    background-color: #eef2f6;\n    color: #364C63;\n    border: 1px solid rgba(54, 76, 99, 0.16);\n}\n\n.forrm-actions button[type=\"button\"]:hover {\n    filter: brightness(0.98);\n    transform: translateY(-1px);\n}\n\n.forrm-actions button:active {\n    transform: scale(0.98);\n}\n\n@media (max-width: 900px) {\n    .business-container {\n        padding: 14px;\n    }\n\n    .business-page-header {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .business-page-header > div {\n        width: 100%;\n    }\n\n    .add-business-btn {\n        position: static;\n        align-self: center;\n    }\n\n    .form-rowww {\n        flex-direction: column;\n    }\n\n    .agent-stats-config-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .agent-stats-config-heading {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .agent-stats-timing-section {\n        grid-template-columns: 1fr;\n    }\n\n    .form-groupppp {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .form-groupppp label,\n    .password-group label,\n    .password-label-group {\n        justify-content: flex-start;\n        min-width: 0;\n        text-align: left;\n    }\n}\n\n@media (max-width: 560px) {\n    .business-container h2 {\n        font-size: 1.45rem;\n    }\n\n    .add-business-btn {\n        width: 100%;\n    }\n\n    .business-card {\n        width: 290px;\n    }\n\n    .business-info p {\n        grid-template-columns: 1fr;\n        gap: 3px;\n    }\n\n    .business-actions {\n        justify-content: flex-start;\n    }\n\n    .info-tooltip {\n        width: min(82vw, 360px);\n        left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
